export type Coach = {
  name: string
  role: string
  /** Foto del coach. Vacío = se muestran las iniciales. */
  avatar?: string
}

/**
 * Coaches de las reseñas (también usados en la fila de prueba del hero).
 */
export const coaches: Coach[] = [
  {
    name: 'Ethan Brooks',
    role: 'Chess Club Head Coach · Austin, Texas, USA',
  },
  {
    name: 'Michael Turner',
    role: 'National Master (NM) · Dallas, Texas, USA',
  },
  {
    name: 'Olivia Bennett',
    role: 'FIDE Instructor · New York, New York, USA',
  },
  {
    name: 'John Emms',
    role: 'GM, FIDE Trainer · Kent, UK',
  },
  {
    name: 'Lorin D’Costa',
    role: 'IM, FIDE Trainer · London, UK',
  },
  {
    name: 'Veeran Rajendiran',
    role: 'Head Coach · Pondicherry, India',
  },
]

export function initials(name: string) {
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()
}
